/*
 * Mobile Menu Accordion Override
 * 
 * - Overrides slide-based navigation with native <details> toggle
 * - Auto-expands a configurable top-level menu item on first open
 */
(function() {
  'use strict';

  // Which top-level item to auto-open (1-based, i.e. 2 = second item)
  const AUTO_OPEN_INDEX = 2;

  function patchThemeHeader() {
    const headerEl = document.querySelector('theme-header');
    if (!headerEl) return;

    const menu = headerEl.querySelector('#mobile-menu');
    if (!menu || !menu.classList.contains('mobile-menu-drawer--accordion')) return;

    // Clone summaries to remove old slide-based event listeners from header.js
    menu.querySelectorAll('summary').forEach(function(summary) {
      const newSummary = summary.cloneNode(true);
      summary.parentNode.replaceChild(newSummary, summary);
    });

    // Remove back button listeners (safety)
    menu.querySelectorAll('.parent-link-back--button').forEach(function(button) {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
    });

    // Auto-expand on first menu open
    let hasAutoExpanded = false;

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class' && menu.classList.contains('active') && !hasAutoExpanded) {
          hasAutoExpanded = true;
          const topLevelItems = menu.querySelectorAll('.mobile-menu--accordion > li > details');
          const idx = AUTO_OPEN_INDEX - 1;
          if (idx >= 0 && idx < topLevelItems.length) {
            topLevelItems[idx].setAttribute('open', '');
          }
        }
      });
    });

    observer.observe(menu, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    requestAnimationFrame(patchThemeHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      requestAnimationFrame(patchThemeHeader);
    });
  }
})();